import React from "react";
import NavbarHead from "../../components/Header/Navbar/NavbarHead";
import { Box } from "@mui/material";
import HeroSection from "./Header Layout/HeroSection";

export default function Header() {
  return (
    <Box
      sx={{
        height: {
          xs: "100vh", // Apply this style for extra-small screens (mobile)
          md: "auto", // Apply this style for medium screens and up (tablet and desktop)
        },
      }}
    >
      <NavbarHead />

      <section id="header" data-aos="fade-up" data-aos-duration="3000">
        <HeroSection />
      </section>
    </Box>
  );
}
